"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.688 17.518 14.03 4.173c-.897-1.564-3.16-1.564-4.058 0l-7.66 13.345C1.422 19.07 2.546 21 4.342 21h15.317c1.794 0 2.92-1.93 2.03-3.482ZM12.7 8.5a.7.7 0 1 0-1.4 0v5.25a.7.7 0 1 0 1.4 0V8.5Zm-.584 7.507L11.999 16l-.11.006A.999.999 0 1 0 13 17a1 1 0 0 0-.883-.993Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WarningFilledIcon24.js.map